import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  width: 100%;
`

export const FooterContainer = styled.div`
  width: 100%;
`
